import classNames from 'classnames';
import * as React from 'react';
import { pickDomAttrs } from '../_util/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Badge = props => {
  const {
    type = 'dot',
    count,
    //undefined时不展示
    overflowCount = 99,
    text,
    //undefined时不展示
    status = 'success',
    ribbonDirection = 'up',
    ribbonTop = 16,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-badge");
  const numberedDisplayCount = count !== undefined && (count > overflowCount ? "".concat(overflowCount, "+") : count);
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsxs("span", {
    ...attrs.data,
    className: classNames(className, baseClassName),
    style: style,
    children: [children, type === 'dot' && /*#__PURE__*/_jsx("span", {
      className: classNames("".concat(baseClassName, "-dot"), {
        ["".concat(status)]: !!status
      })
    }), type === 'count' && numberedDisplayCount !== false && /*#__PURE__*/_jsx("span", {
      className: classNames("".concat(baseClassName, "-count"), {
        ["".concat(status)]: !!status
      }),
      children: numberedDisplayCount
    }), type === 'text' && text !== undefined && /*#__PURE__*/_jsx("span", {
      className: classNames("".concat(baseClassName, "-text"), {
        ["".concat(status)]: !!status
      }),
      children: text
    }), type === 'ribbon' && !!text && /*#__PURE__*/_jsxs("div", {
      className: classNames("".concat(baseClassName, "-ribbon"), {
        ["".concat(baseClassName, "-ribbon-").concat(ribbonDirection)]: !!ribbonDirection,
        ["".concat(status)]: !!status
      }),
      style: {
        top: "".concat(ribbonTop, "px")
      },
      children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("div", {
          className: "ribbon-text",
          children: text
        })
      })]
    })]
  });
};
export default Badge;